"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DeleteForeverRounded_1 = __importDefault(require("@mui/icons-material/DeleteForeverRounded"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const clsx_1 = __importDefault(require("clsx"));
const ButtonIconSolo_1 = __importDefault(require("../../../global/Button/ButtonIconSolo"));
const ButtonDrag_1 = __importDefault(require("../../../global/Button/ButtonDrag"));
const ArrayOfGroupsItem = (props) => {
    const { element, index, disabled, fixedItemCount } = props;
    const isAdditionalItem = index >= fixedItemCount;
    const classes = (0, clsx_1.default)(element.className, 'flex align-items-start gap-x-1 mb-2');
    if (!isAdditionalItem) {
        return react_1.default.createElement("div", { className: classes }, element.children);
    }
    return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { key: element.key, draggableId: `draggable-${element.key}`, index: index, isDragDisabled: disabled }, (provided) => (react_1.default.createElement("div", { ref: provided.innerRef, ...provided.draggableProps, key: element.key, className: (0, clsx_1.default)(element.className, 'component-group') },
        react_1.default.createElement("div", { className: "component-group-header" },
            react_1.default.createElement("div", { className: "flex gap-x-1" },
                react_1.default.createElement(ButtonDrag_1.default, { canReorder: !disabled, dragHandle: provided, className: "mr-1" })),
            react_1.default.createElement(ButtonIconSolo_1.default, { "aria-label": "Delete", tooltip: "Delete", disabled: element.disabled, onClick: element.onDropIndexClick(element.index) },
                react_1.default.createElement(DeleteForeverRounded_1.default, null))),
        react_1.default.createElement("div", { className: "component-group-body" }, element.children)))));
};
exports.default = ArrayOfGroupsItem;
